import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowsService {
  constructor() {}

  alert(message: string) {
    window.alert(message);
  }

  reload() {
    window.location.reload();
  }

  setInterval(callback: Function, duration: number) {
    return window.setInterval(callback, duration);
  }

  clearInterval(timer) {
    if (timer) {
      window.clearInterval(timer);
    }
  }
}
